module.exports = __webpack_public_path__ + "static/media/accessible.64827b47.png";